const translations = {
    "New task": "Neuen Beratungslauf erstellen",
    "Edit": "Bearbeiten",
    "Delete": "Löschen",
    "Move up": "Nach oben",
    "Move down": "Nach unten",
    "Copy": "Kopieren",
    "Cut": "Ausschneiden",
    "Paste": "Einfügen",
    "Indent": "Einrücken",
    "Outdent": "Ausrücken",
};

export const translateToolbarButtons = (buttons) => {
    return buttons.map(button => {
        const updated = { ...button };

        if (button.menuText && translations[button.menuText]) {
            updated.menuText = translations[button.menuText];
        }

        if (button.text && translations[button.text]) {
            updated.text = translations[button.text];
        }

        return updated;
    });
};
